export enum GenericRoles {
    Edit = "Catalogue.Generic Roles.Edit",
    View = "Catalogue.Generic Roles.View",
}

export enum LegalEntityTypes {
    Edit = "Catalogue.Legal Entity Types.Edit",
}

export enum AssetTypes {
    Edit = "Catalogue.Asset Types.Edit",
}

export enum PortfolioTypes {
    Edit = "Catalogue.Portfolio Types.Edit",
}

export enum InvestorReferralTypes {
    Edit = "Catalogue.Investor Referral Types.Edit",
}

export enum Groups {
    Edit = "Catalogue.Groups.Edit",
}

export enum Sectors {
    Edit = "Catalogue.Sectors.Edit",
}

export enum Pipelines {
    Edit = "Catalogue.Pipelines.Edit",
}

export enum Holidays {
    Edit = "Catalogue.Holidays.Edit",
}

export enum Countries {
    Edit = "Catalogue.Countries.Edit",
}

export enum Banks {
    Edit = "Catalogue.Banks.Edit",
}

export enum InternalRatings {
    Edit = "Catalogue.Internal Ratings.Edit",
}

export enum CommissionTypes {
    Edit = "Catalogue.Commission Types.Edit",
    Authorise = "Catalogue.Commission Types.Authorise",
}

export enum Rates {
    Edit = "Catalogue.Rates.Edit",
    Authorise = "Catalogue.Rates.Authorise",
}

export enum Entities {
    Edit = "Catalogue.Entities.Edit",
}

export enum DocumentTypes {
    Edit = "Catalogue.Document Types.Edit",
}

export enum LadderAges {
    Edit = "Catalogue.Ladder Ages.Edit",
}

export enum LadderProjections {
    Edit = "Catalogue.Ladder Projections.Edit",
}

export enum RiskRating {
    Edit = "Catalogue.Risk Rating.Edit",
}

export enum AssetClass {
    Edit = "Catalogue.Asset Class.Edit",
}

export enum PRPRates {
    Edit = "Catalogue.PRP Rates.Edit",
}

export enum IDTRates {
    Edit = "Catalogue.IDT Rates.Edit",
}

export enum CostRecoveryPremiums {
    Edit = "Catalogue.Cost Recovery Premiums.Edit",
}

export enum IssuerTypes {
    Edit = "Catalogue.Issuer Types.Edit",
}

export enum ShareTypes {
    Edit = "Catalogue.Share Types.Edit",
}

export enum BankAccountTypes {
    Edit = "Catalogue.Bank Account Types.Edit",
}

export enum BankAccounts {
    Edit = "Catalogue.Bank Accounts.Edit",
}

export enum Title {
    Edit = "Catalogue.Title.Edit",
}

export enum IntraGroups {
    Edit = "Catalogue.Intra Groups.Edit",
}

export enum BalanceSheetSizes {
    Edit = "Catalogue.Balance Sheet Sizes.Edit",
}

export enum NoteTypes {
    Edit = "Catalogue.Note Types.Edit",
}

export enum Notes {
    Edit = "Catalogue.Notes.Edit",
}

export enum GLAccountTypes {
    Edit = "Catalogue.GL Account Types.Edit",
}

export enum SARSIDTypes {
    Edit = "Catalogue.SARSID Types.Edit",
}

export enum DwtExemption {
    Edit = "Catalogue.Dwt Exemptions.Edit",
}

export enum InvestmentSetup {
    View = "Catalogue.Investment Setup.View",
    Edit = "Catalogue.Investment Setup.Edit",
}

export enum DwtExemptions {
    Edit = "Catalogue.Dwt Exemptions.Edit",
}

export enum NoticePeriod {
    Edit = "Catalogue.Notice Period.Edit",
}

export enum ContactTypes {
    Edit = "Catalogue.Contact Types.Edit",
}

export enum SARSNatureOfPerson {
    Edit = "Catalogue.SARS Nature Of Person.Edit",
}

export enum ProductType {
    Edit = "Catalogue.Product Type.Edit",
    Authorise = "Catalogue.Product Type.Authorise",
}

export enum MergeTemplate {
    Edit = "Catalogue.Merge Template.Edit",
    Authorise = "Catalogue.Merge Template.Authorise",
}

export enum DistributionType {
    Edit = "Catalogue.Distribution Type.Edit",
}